module.exports = __webpack_public_path__ + "img/cor-logo-bw.917c5022.png";